import React from "react";
import Tooltip from "@mui/material/Tooltip";

export const PUBLISHED_MODEL_TOOLTIP =
  "You need to make changes in Sandbox. Published labor standards cannot be edited.";

// Keep read-only inspection controls usable while explaining non-editable cells.
export default function PublishedModelTableTooltip({ readOnly, children }) {
  const [anchor, setAnchor] = React.useState(null);
  const timeoutRef = React.useRef(null);

  React.useEffect(() => {
    setAnchor(null);
    return () => window.clearTimeout(timeoutRef.current);
  }, [readOnly]);

  const showTooltip = (event) => {
    if (!readOnly) return;
    if (event.target.closest('button, a, input, [role="button"]:not(tr)')) {
      setAnchor(null);
      return;
    }
    window.clearTimeout(timeoutRef.current);
    setAnchor(event.target.closest("td, th") || event.currentTarget);
    timeoutRef.current = window.setTimeout(() => setAnchor(null), 2200);
  };

  return (
    <Tooltip
      title={PUBLISHED_MODEL_TOOLTIP}
      open={Boolean(readOnly && anchor)}
      onClose={() => setAnchor(null)}
      disableHoverListener
      disableFocusListener
      disableTouchListener
      describeChild
      PopperProps={{ anchorEl: anchor }}
    >
      {React.cloneElement(children, {
        tabIndex: readOnly ? 0 : children.props.tabIndex,
        onClick: (event) => {
          children.props.onClick?.(event);
          showTooltip(event);
        },
        onKeyDown: (event) => {
          children.props.onKeyDown?.(event);
          if (
            readOnly &&
            event.target === event.currentTarget &&
            (event.key === "Enter" || event.key === " ")
          ) {
            event.preventDefault();
            showTooltip(event);
          }
        },
      })}
    </Tooltip>
  );
}
